const normalized = value => (value == null ? null : String(value));
const aliases = value => {
  const id = normalized(value);
  if (!id) return [];
  const legacy = id.match(/^https?:\/\/[^/]+\/avatars\/([^/]+)\/$/);
  return legacy ? [id, legacy[1]] : [id];
};

export function avatarLookupId(value, persistenceApiUrl) {
  const id = normalized(value);
  if (!id) return null;
  try {
    const url = new URL(id);
    const persistence = new URL(persistenceApiUrl);
    const basePath = persistence.pathname.replace(/\/$/, "");
    const file = url.pathname.slice(basePath.length).match(/^\/files\/([^/.]+)\.glb$/);
    if (
      url.origin === persistence.origin &&
      url.pathname.startsWith(`${basePath}/`) &&
      file &&
      !url.search &&
      !url.hash
    ) {
      return `${persistenceApiUrl.replace(/\/$/, "")}/assets/${file[1]}`;
    }
  } catch {
    // IDs and unconfigured persistence origins require no URL conversion.
  }
  return aliases(id).slice(-1)[0];
}

export function toAvatarSelection(requestedId, entry) {
  if (requestedId == null && !entry) return null;
  const avatarId = normalized(entry?.sid || entry?.avatar_id || entry?.id || requestedId);
  // URL-only fetches expose a rendering proxy in gltf_url; retain their requested model URL.
  const originalUrl =
    /^https?:\/\//.test(String(requestedId)) && entry?.avatar_id === requestedId && !entry?.id && !entry?.sid
      ? requestedId
      : null;
  const avatarUrl = entry?.url || entry?.asset?.url || originalUrl || entry?.gltf_url || entry?.gltfs?.avatar || null;
  const thumbnail = entry?.files?.thumbnail ?? entry?.thumbnail ?? entry?.images?.preview?.url ?? null;
  return {
    avatarId,
    avatarUrl,
    thumbnail,
    identity: [...new Set([requestedId, avatarId, entry?.id, entry?.asset_id, avatarUrl].flatMap(aliases))]
  };
}

export function sameAvatarIdentity(left, right) {
  if (!left || !right) return left === right;
  return left.identity.some(alias => right.identity.includes(alias));
}
